import cameraTemplate from './cameraTemplate';
import permission from "@/utilities/permissions"
const camera = {};



function playServiceEnabled(){
  return new Promise(function(resolve,reject){
    var success = function(response) {
      resolve(response.isGooglePlayServicesAvailable)
    } 
    var failure = function(response) {
      resolve(false)
    }
    try{ GooglePlayServicesCheck.check(success, failure); }catch(e){ resolve(false) }
  })
}


camera.getPictureViaCordova = function (options) {
  return new Promise( function(resolve, reject)  {
    console.log("Picture promise",options)
    window.navigator.camera.getPicture(function(e){
        console.log("Got puc")
        this.resolve(e) 
      }.bind({resolve:resolve}),
      function(e) { 
        this.reject(e) 
      }.bind({reject:reject}), options);
  });
};


camera.getPictureViaHTML = async function (ctx, options) {
  return new Promise(((resolve, reject) => {
    ctx.$modal.show(cameraTemplate, {
      text: 'This text is passed as a property',
    }, {
      height: 'auto',
      width: '300'
    }, {
      closed: (event) => {
        reject();
      },
      snap: (event) => {
        resolve(event);
      },
    });
  }));
};


camera.getPicture = async function (ctx, options) {
  console.log("Getting pucture " , window.device)


  var playService = true

  if(device.platform.toLowerCase() == "android" && parseInt( device.version, 10 ) <= 6) {
    playService =  await playServiceEnabled() 
    console.log("Play service is "+playService);
  }

  
  if ( (device.platform.toLowerCase() == 'android' && !playService )|| (device.platform.toLowerCase() == "browser") ){

  

      console.log("Play service disabled or browser")

      try{

        
        if(!await permission.camera.authorized()){
          console.log("Unauthorized")
          try{
            await permission.camera.request()
            console.log("Requester")
          }catch(e){
            console.log(e)  
          } 
        } }catch(e){
          console.log(e)
        }
        
        console.log("Get via web interface")
      return camera.getPictureViaHTML(ctx, options);
   

    
  }else  { 

    console.log("Cordova capture")
   
    
    try{
      if(!await permission.camera.authorized()){
        console.log("Unautorized")
        try{
          console.log("Req PERm")
          await permission.camera.request()
          console.log("Done Req PERm")
        }catch(e){
          console.log(e)  
        } 
      } }catch(e){
        console.log(e)
      }
      
      console.log("Capturing")
      return camera.getPictureViaCordova(options);
  
  }
  

};

export default camera;
